import PropTypes from 'prop-types';

const StatisticsFullscreenIcon = ({ className, size = 17 }) => (
	<svg className={className} width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
		<rect x='5.55' y='5.55' width='4.9' height='4.9' rx='1' stroke='currentColor' strokeWidth='1.25' opacity='0.48' />
		<path d='M5.85 2.6H3.55A1.2 1.2 0 0 0 2.35 3.8V6.1' stroke='currentColor' strokeWidth='1.4' strokeLinecap='round' strokeLinejoin='round' />
		<path d='M10.15 2.6h2.3a1.2 1.2 0 0 1 1.2 1.2V6.1' stroke='currentColor' strokeWidth='1.4' strokeLinecap='round' strokeLinejoin='round' />
		<path d='M10.15 13.4h2.3a1.2 1.2 0 0 0 1.2-1.2v-2.3' stroke='currentColor' strokeWidth='1.4' strokeLinecap='round' strokeLinejoin='round' />
		<path d='M5.85 13.4H3.55a1.2 1.2 0 0 1-1.2-1.2v-2.3' stroke='currentColor' strokeWidth='1.4' strokeLinecap='round' strokeLinejoin='round' />
	</svg>
);

StatisticsFullscreenIcon.propTypes = {
	className: PropTypes.string,
	size: PropTypes.number,
};

export default StatisticsFullscreenIcon;
